import { Button } from "@mui/material";
import { useMessageDialogHandlers } from "../../../App/State/Hooks/MessageDialog/useMessageDialog";
import { ISelectedCandidate } from "../../../App/State/Slices/MessageDialogSlice";
import { ICandidate } from "../../../App/Typings/Candidate";
import { IMessageContainers } from "../../../MessageComponents/Enums/MessageEnums";
import { MemoMessageDialogGroupTabs } from "../../../MessageComponents/MessageDialog/MessageDialogGroupTabs";

export default function BulkMessageModal({
  selectedCandidates,
  selectedCount,
}: {
  selectedCandidates: ICandidate[];
  selectedCount: number;
}) {
  const { handleOpenDialog } = useMessageDialogHandlers();

  const candidateEntities = selectedCandidates.reduce(
    (acc, c) => {
      acc[c.id] = {
        candidateId: c.id,
        firstName: c.firstName,
        lastName: c.lastName,
        hasEmail: c.emailAddresses.length > 0,
        hasPhone: c.phoneNumbers.find((phone) => phone.isValid) !== undefined,
        unsubscribed: c.unsubscribed,
        emailAddress: c.emailAddresses.length > 0 ? c.emailAddresses[0].emailAddress : undefined,
        phoneNumber:
          c.phoneNumbers.find((phone) => phone.isValid) !== undefined
            ? c.phoneNumbers.find((phone) => phone.isValid)?.phoneNumber
            : undefined,
      };
      return acc;
    },
    {} as Record<string, ISelectedCandidate>,
  );
  const candidateIds = selectedCandidates.map((c) => c.id);

  const openDialog = () => {
    handleOpenDialog({
      isGroupTabsOpen: true,
      containerType: IMessageContainers.BulkTextNow,
      candidateIds,
      candidateEntities,
    });
  };

  return (
    <>
      <Button
        data-test="bulk-message-button"
        variant="text"
        disabled={selectedCount <= 0}
        onClick={() => openDialog()}
      >
        Message {selectedCount} candidate(s)
      </Button>
      <MemoMessageDialogGroupTabs />
    </>
  );
}
